/**
 * Created by Jie Gao on 05/24/2019.
 */

import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GGReelSymbol} from "./GGReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {FontStyleConfig} from "../config/FontStyleConfig";
import {GGGameConfig} from "../GGGameConfig";

export class GGReelSymbolW extends GGReelSymbol {
    private _wildCloth:PIXI.Sprite;
    private _wildMultiplier:PIXI.BitmapText;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    //for symbols: W
    protected createWinFrame():void {
        if(this._winFrame){
            this._winFrame.destroy();
        }
        this._winFrame = this.createSpineAnimation("Highlight", 1);
        this.addChild(this._winFrame);
        this._winFrame.visible = false;
        this._winFrame.renderable = false;
    }

    protected createSymAnimation():void {
        if(this._symbolAnimations){
            this._symbolAnimations.destroy();
        }
        let symName:string = ((this.symName.length > 1) ? "W3" : this.symName);
        this._symbolAnimations = this.createSpineAnimation(symName);
        this.addChild(this._symbolAnimations);
        this._symbolAnimations.visible = false;
        this._symbolAnimations.renderable = false;
    }

    public createMiddleLayerGraphics():void {
        if(!this._wildCloth) {
            let symName:string = ((this.symName.length > 1) ? "W3" : this.symName);
            this._wildCloth = this.createEmptySprite("");
            this._wildCloth.texture = GameResources.getTextures(symName + "_cloth")[0];

            this.addChild(this._wildCloth);
        }
    }

    private createWildMultiplier():void {
        this._wildMultiplier = new PIXI.BitmapText("", FontStyleConfig.WildMultiplier);
        this._wildMultiplier.visible = false;
        this._wildMultiplier.position.set(0, 0);
    }

    private addMultiplier():void {
        if(this.symName.length < 2) {
            return;
        }
        const symName:string = this.symName;
        const multiplier:number = parseInt(symName.substring(1));
        this.patchWildMultiplier(multiplier);
    }

    public fadeInMultiplier():void {
        if(!this._wildMultiplier) {
            return;
        }
        new TweenLite(this._wildMultiplier, 0.06, {alpha :1});
    }

    public hideMultiplier():void {
        if(!this._wildMultiplier) {
            return;
        }
        this._wildMultiplier.alpha = 0;
    }

    private patchWildMultiplier(multiplier:number):void {
        if(multiplier < 4) {
            return;
        }
        if(!this._wildMultiplier) {
            this.createWildMultiplier();
        }
        const multiplierNumber:number = GGGameConfig.instance.MULTIPLIER[multiplier].multiplier;
        const isEleven:boolean= multiplier === 11;
        this._wildMultiplier.letterSpacing = isEleven?-60:-40;
        this._wildMultiplier.text = `x ${isEleven?" ":""}${multiplierNumber}`;
        this._wildMultiplier.scale.set(this._displayScale, this._displayScale);
        this._wildMultiplier.position.set(-this._wildMultiplier.width * 0.5, 0);
        this._wildMultiplier.visible = true;
        this.addChild(this._wildMultiplier);
    }

    public getExplodeAnimation(stateAnimation:TimelineSprite):TimelineLite {
        const tl:TimelineLite = super.getExplodeAnimation(stateAnimation);
        if(this._wildCloth) {
            tl.add(new TweenLite(this._wildCloth, 0.3, {alpha : 0}), 0);
        }
        if(this._wildMultiplier) {
            tl.add([
                ()=>{this.addChild(this._wildMultiplier);},
                new TweenLite(this._wildMultiplier, 0.8, {alpha : 0})], 0.1);
        }
        return tl;
    }

    public updateBackground(symHeight:number):void {
        super.updateBackground(symHeight);
        let symName:string = (this.symName.length > 1) ? "W3" : "W";
        this._symBackground.texture = GameResources.getTextures(symName+"_bg")[0];
        this._symFrame.texture = GameResources.getTextures(symName+"_frame")[0];
        this._symBackground.height = this.symHeight;
        this._symFrame.height = this.symHeight;
        this._wildCloth.scale.set(this._displayScale, this._displayScale);

        for(let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if(state != null) {
                state.scale.set(this._displayScale, this._displayScale);
            }
        }
        this.addMultiplier();
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            if(this._wildMultiplier) {
                this.addChild(this._wildMultiplier);
            }
            if(this._wildCloth) {
                this._wildCloth.scale.set(this._displayScale, this._displayScale);
            }
            return true;
        }
        return false;
    }

    public onRemove():void {
        super.onRemove();

        if(this._wildMultiplier) {
            this.removeChild(this._wildMultiplier);
        }

        if(this._wildCloth) {
            this.removeChild(this._wildCloth);
        }
    }
}